import * as React from 'react';
import Alert from '@mui/material/Alert';
import {AlertTitle} from "@mui/material";

type PropsType = {
    title?: string,
    message: string,
    status: 'success' | 'info' | 'warning' | 'error',
    isLink?: boolean,
    width?: string
}

const CustomAlert: React.FC<PropsType> = ({message, status, title, isLink = false, width}) => {

    return (
        <Alert severity={status} sx={{maxWidth: width}} color={status}>
            {title && <AlertTitle>{title}</AlertTitle>}
            <div>
                <strong>{message}</strong>
            </div>

        </Alert>
    );
};

export default CustomAlert;